<template>
  <div>
    <FormMultiSelect 
      :value="value"
      @input="$emit('input', $event)"
      :field="field"
      :options="permissionList"
      :loading="permissionListLoading"
      placeholder="Select Permissions"
      v-if="!errorLabel && editable"
    />
    <span v-if="!editable">
      <span class="label label-success mr-1" v-for="code in value" :key="code">
        {{getLookupName(permissionList, code)}}
      </span>
    </span>
    <span class="text-danger" v-if="errorLabel">{{errorLabel}}</span>
  </div>
</template>

<script>
import form from '@/mixins/form'

export default {
  name: "AutomationPermissionListField",
  mixins: [form],
  props: {
    field: String,
    value: Array,
    editable: Boolean
  },
  data() {
    return {
      permissionList: [],
      permissionListLoading: false,
      errorLabel: null
    }
  },
  mounted() {
    // Get permission list
    // FUTURE: Somehow send a promise to the select component. It can handle loading state based on promise
    this.permissionListLoading = true
    this.errorLabel = null

    this.$apiService.coreService.getPermissionTypes()
    .then(list => {
      this.permissionList = list.data.map(permission => {
        return {
          value: permission.code,
          name: `${permission.category} : ${permission.name}`
        }
      })
      this.permissionListLoading = false
    })
    .catch(err => {
      this.permissionListLoading = false
      if(err.response.status == 403)
        this.errorLabel = 'Permission denied to permission list'
      else
        this.errorLabel = 'Error accessing permission list'
    })
  },
  computed: {
  },
  methods: {
    
  }
}
</script>